import './instrument-chip.css'
export const InstrumentChip = ({ instrument, onClick }) => {
    return (
        <div className="instrument-chip__wrapper" onClick={() => onClick(instrument)}>
            <div className="instrument-chip__name">{instrument.name}</div>
            <div className="instrument-chip__x">x</div>
        </div>
    )
}